/**
 * snippets/back-block.liquid
 * ＜ Back ボタンの制御
 * 外部サイトからの流入もBackボタンで内部遷移させる。
 *
 * referrerがdataset.targetに関連する場合は、history.back、
 * 関連しない・存在しない場合は、dataset.targetに遷移
 */

document.addEventListener('DOMContentLoaded', () => {
  const $backButtons = document.querySelectorAll('.js-back-block-button')
  if (!$backButtons.length) {
    return
  }
  const onClick = event => {
    const target = event.target.dataset.target
    if (!document.referrer) {
      window.location.pathname = target
    }
    const regExp = new RegExp(`^${target}`)
    const referrer = new URL(document.referrer)
    if (regExp.test(referrer.pathname)) {
      window.history.back()
    } else {
      window.location.pathname = target
    }
  }
  $backButtons.forEach($backButton => {
    $backButton.addEventListener('click', onClick)
  })
})
